import { render, staticRenderFns } from "./workerHealthSkill.vue?vue&type=template&id=51ee7070"
import script from "./workerHealthSkill.vue?vue&type=script&lang=js"
export * from "./workerHealthSkill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports